import React from 'react'
import type { FormikValues } from 'formik'
import { useField } from 'formik'

import { TtTextArea } from '@23/react'

import type {
  FieldNameMatchingAcceptedType,
  FormikFormControlProps,
} from './index'

const TtTextAreaFormik = <FV extends FormikValues>({
  name,
  validate,
  invalid,
  errorText,
  ...props
}: FormikFormControlProps<'tt-text-area'> & {
  name: FieldNameMatchingAcceptedType<
    FV,
    HTMLTtTextAreaElement['value'] | undefined
  >
}) => {
  const [field, meta] = useField<HTMLTtTextAreaElement['value']>({
    name,
    type: 'text',
    validate,
  })

  return (
    <TtTextArea
      {...props}
      name={field.name}
      value={field.value}
      onBlur={field.onBlur}
      onTt-change={field.onChange}
      onTt-input={field.onChange}
      invalid={meta.touched && (!!meta.error || invalid)}
      errorText={meta.error ?? errorText}
    />
  )
}

export { TtTextAreaFormik }
